import { Link } from "react-router-dom";

const highlights = [
  { icon: "ri-refresh-line", title: "每日更新", desc: "持续同步最新剧集与影视资讯" },
  { icon: "ri-filter-3-line", title: "精准筛选", desc: "按类型、地区、年份快速定位" },
  { icon: "ri-book-open-line", title: "剧情速览", desc: "分集剧情介绍，回顾更轻松" },
];

export default function SiteIntro() {
  return (
    <section className="px-4 md:px-10 py-6 md:py-10">
      <div className="max-w-7xl mx-auto bg-background-100 border border-background-200/60 rounded-lg overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="p-6 md:p-10 flex flex-col justify-center">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-50 leading-snug">
              关于热情的邻居
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-400 leading-relaxed">
              热情的邻居是一个聚焦影视内容的信息平台，围绕“热情的邻居”相关影视作品及热门剧集，提供剧情介绍、
              资料速览与相关推荐。我们希望通过清晰的分类与便捷的搜索，帮助每一位影视爱好者快速找到想看的内容，
              轻松追踪、随时回顾。
            </p>
            <div className="mt-6">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-5 h-10 rounded-md bg-accent-500 hover:bg-accent-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors"
              >
                了解更多
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-1 divide-y sm:divide-y-0 sm:divide-x lg:divide-x-0 lg:divide-y divide-background-200/60 border-t lg:border-t-0 lg:border-l border-background-200/60">
            {highlights.map((item) => (
              <div key={item.title} className="p-5 md:p-6 flex items-center gap-4">
                <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-lg bg-secondary-100/70 text-secondary-900">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <span>
                  <span className="block text-sm font-semibold text-foreground-50">{item.title}</span>
                  <span className="block text-xs text-foreground-500 mt-1">{item.desc}</span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}